// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"_93444fe79c--breadcrumbs--KqVG7","breadcrumbs-link":"_93444fe79c--breadcrumbs-link--JAzZV","breadcrumbs-delimiter":"_93444fe79c--breadcrumbs-delimiter--CcXCV"};